import { render, staticRenderFns } from "./ShopEditionProductPicture.vue?vue&type=template&id=16b40bec&scoped=true&"
import script from "./ShopEditionProductPicture.vue?vue&type=script&lang=js&"
export * from "./ShopEditionProductPicture.vue?vue&type=script&lang=js&"
import style0 from "./ShopEditionProductPicture.vue?vue&type=style&index=0&id=16b40bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b40bec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VIcon,VImg,VLayout,VProgressCircular})
